/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 17:23:14
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-13 16:58:25
 * @Description: file content
 */
export default {
    env: {
        test: {
            site: {
                appid: "",
                protocol: "",
                domain: "",
            },
            routersActWxauth: {
                fake: {
                    zt: {
                        actOpenId: 'oj3y9wJIWmCfZ90py4wJR5qT5c8o',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    ljf: {
                        actOpenId: 'oj3y9wJASe2OqpMUHyJ-8hsxsNvE',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    df: {
                        actOpenId: 'oj3y9wBrjK0w4pf04S3m_Pp6Ufhw',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    zfs: {
                        actOpenId: 'oj3y9wJGZPidkyGw5MT0577Ns28k',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    wj: {
                        actOpenId: 'oj3y9wNQ09AnwOAlaDkcPfqjMoUs',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    test:{
                        actOpenId: 'oj3y9wHx8cKPTvhg5lAtraXIhx9I',
                        actAppId: 'wx01f0b018d4951434',
                    }
                }
            },
            servicesActWxjssdk: {
                appid: 'wx01f0b018d4951434',
            },
            apiActLogicDengfan: {
                protocol: "",
                domain: "",
            },
            apiActLogicZouTeng: {
                protocol: "",
                domain: "",
            },
            httpActLogicDengfan: {
                appId: "",
                infoId: 1,
            },
            httpActLogicZouTeng: {
                appId: "",
                infoId: 1,
            },
        },
        prod: {
            site: {
                appid: "",
                protocol: "",
                domain: "",
            },
            routersActWxauth: {
                fake: {
                    zt: {
                        actOpenId: 'oPjuu6p2-rzHVH7TtRY_eQyACwNY',
                        actAppId: 'wx1bb4b9359c70a06a',
                    },
                    ljf: {
                        actOpenId: 'oPjuu6mzBRuQYMqayAYS8FvgHj4U',
                        actAppId: 'wx1bb4b9359c70a06a',
                    },
                    df: {
                        actOpenId: 'oj3y9wBrjK0w4pf04S3m_Pp6Ufhw',
                        actAppId: 'wx1bb4b9359c70a06a',
                    },
                    wj: {
                        actOpenId: 'oPjuu6mVmvoW3fJWVp1mU-bi5RtA',
                        actAppId: 'wx1bb4b9359c70a06a',
                    },
                    test: {
                        actOpenId: 'oPjuu6tsfJ6qFuU7l_Xz6QZIKVDc',
                        actAppId: 'wx1bb4b9359c70a06a',
                    },
                    zfs: {
                        actOpenId: 'oPjuu6n-ugROMALhOsibxCjbLV28',
                        actAppId: 'wx1bb4b9359c70a06a',
                    }
                }
            },
            servicesActWxjssdk: {
                appid: 'wx01f0b018d4951434',
            },
            apiActLogicDengfan: {
                protocol: "",
                domain: "",
            },
            apiActLogicZouTeng: {
                protocol: "",
                domain: "",
            },
            httpActLogicDengfan: {
                appId: "",
                infoId: 1,
            },
            httpActLogicZouTeng: {
                appId: "",
                infoId: 1,
            },
        }
    },
    imgHost: 'http://assets.rurushishi.com/activies/yygj-2022-11/', // 静态素材oss地址
};